const Mn = require('backbone.marionette');

module.exports = Mn.Behavior.extend({
    onDomRefresh: function() {
        const options = this.getOption('options');
        options.trigger = 'hover';
        this.$('[data-toggle="tooltip"]').tooltip(options);
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/behavior/tooltip.js